import FS from '../FetchService';

export default class GradeService {
  static fetch(params) {
    return FS.get(`/grades?${params}`);
  }
}